import { render, staticRenderFns } from "./DiagCourseInput.vue?vue&type=template&id=c193fec0&scoped=true&"
import script from "./DiagCourseInput.vue?vue&type=script&lang=js&"
export * from "./DiagCourseInput.vue?vue&type=script&lang=js&"
import style0 from "./DiagCourseInput.vue?vue&type=style&index=0&id=c193fec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c193fec0",
  null
  
)

export default component.exports